import React, {memo, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {plusMenuSelector} from "./plusMenu.selector";
import {cardEditorActions} from "../../cardEditor.slice";
import { styled } from "styled-components";
import { ThemeProps } from "../../../../styles/theme";

const Root = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
`;

const UnderLayer = styled.div`
    width: 100%;
    height: 100%;
`;

const MenuLayer = styled.div<ThemeProps>`
    position: absolute;
    right: 10px;
    top: 43px;
    padding: 10px 20px;
    background-color: ${props => props.theme.primaryBackground};
    border: ${props => props.theme.primaryBorder} 1px solid;
    display: flex;
    flex-direction: column;
`;

const PlusMenuComponent = memo(() => {
    const stateProps = useSelector(plusMenuSelector);
    const dispatch = useDispatch();
    const clickOutsideHandler = useCallback(() => {
        dispatch(cardEditorActions.closePlusMenu());
    }, [dispatch])

    return !stateProps.isMenuOpen
        ? <></>
        : (
            <Root>
                <UnderLayer onClick={clickOutsideHandler}/>
                <MenuLayer>
                    <span>Hint</span>
                    <span>Image</span>
                </MenuLayer>
            </Root>
        );
});

PlusMenuComponent.displayName = 'PlusMenuComponent';

export { PlusMenuComponent as PlusMenu };
